import {API} from "aws-amplify";
import {awsApiName} from "../../shared/amplify/amplify-utils";
import {CountyLinkResource} from "../../entity/resource/county-link-resource";

export default class CountyLinkAgent {

    getCountyLinks = async (countyId: string): Promise<CountyLinkResource[]> => {
        return await API.get(awsApiName, `/county-link-registry?countyID=${countyId}`, {});
    }
}
